import { render, staticRenderFns } from "./Technic.vue?vue&type=template&id=5e560493&"
import script from "./Technic.vue?vue&type=script&lang=js&"
export * from "./Technic.vue?vue&type=script&lang=js&"
import style0 from "./Technic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports